// frontend/src/constants/index.js
// Updated: March 25, 2025

// API URL - Change this for different environments
export const API_URL = (process.env.REACT_APP_API_URL || 'https://api.annuityleadsforagents.com');

// Log the API URL being used (helpful for debugging)
console.log('Using API URL:', API_URL);

// Lead statuses with expanded options
export const LEAD_STATUSES = {
  AVAILABLE: 'available',
  PURCHASED: 'purchased',
  CONTACTED: 'contacted',
  QUALIFIED: 'qualified',
  UNQUALIFIED: 'unqualified',
  CONVERTED: 'converted',
  EXPIRED: 'expired',
  ARCHIVED: 'archived'
};

// Email notification preferences
export const EMAIL_PREFERENCES = {
  IMMEDIATE: 'immediate',
  DAILY: 'daily',
  WEEKLY: 'weekly',
  DISABLED: 'disabled'
};

// US States mapping object for form components
export const US_STATES = {
  'AL': 'Alabama',
  'AK': 'Alaska',
  'AZ': 'Arizona',
  'AR': 'Arkansas',
  'CA': 'California',
  'CO': 'Colorado',
  'CT': 'Connecticut',
  'DE': 'Delaware',
  'FL': 'Florida',
  'GA': 'Georgia',
  'HI': 'Hawaii',
  'ID': 'Idaho',
  'IL': 'Illinois',
  'IN': 'Indiana',
  'IA': 'Iowa',
  'KS': 'Kansas',
  'KY': 'Kentucky',
  'LA': 'Louisiana',
  'ME': 'Maine',
  'MD': 'Maryland',
  'MA': 'Massachusetts',
  'MI': 'Michigan',
  'MN': 'Minnesota',
  'MS': 'Mississippi',
  'MO': 'Missouri',
  'MT': 'Montana',
  'NE': 'Nebraska',
  'NV': 'Nevada',
  'NH': 'New Hampshire',
  'NJ': 'New Jersey',
  'NM': 'New Mexico',
  'NY': 'New York',
  'NC': 'North Carolina',
  'ND': 'North Dakota',
  'OH': 'Ohio',
  'OK': 'Oklahoma',
  'OR': 'Oregon',
  'PA': 'Pennsylvania',
  'RI': 'Rhode Island',
  'SC': 'South Carolina',
  'SD': 'South Dakota',
  'TN': 'Tennessee',
  'TX': 'Texas',
  'UT': 'Utah',
  'VT': 'Vermont',
  'VA': 'Virginia',
  'WA': 'Washington',
  'WV': 'West Virginia',
  'WI': 'Wisconsin',
  'WY': 'Wyoming'
};

// Simple array of state names (for backward compatibility)
export const US_STATE_NAMES = Object.values(US_STATES);

// Status badge styles for different lead statuses
export const STATUS_BADGE_CLASSES = {
  available: 'bg-green-100 text-green-800',
  purchased: 'bg-blue-100 text-blue-800',
  contacted: 'bg-yellow-100 text-yellow-800',
  qualified: 'bg-purple-100 text-purple-800',
  unqualified: 'bg-red-100 text-red-800',
  converted: 'bg-indigo-100 text-indigo-800',
  expired: 'bg-gray-100 text-gray-800',
  archived: 'bg-gray-100 text-gray-500'
};

// Price configuration
export const DEFAULT_LEAD_PRICE = 50.00;

// Pagination defaults
export const PAGINATION = {
  DEFAULT_PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: [10, 20, 50, 100]
};